import React, { HTMLAttributes } from 'react';
import { Col, FormCheck, FormGroup } from 'react-bootstrap';
import cs from './RequiredAchievementFormGroup.module.scss';

type RequiredAchievementFormGroupProps = HTMLAttributes<HTMLDivElement> & {
  value: boolean,
  onChange: (value: boolean) => void
  disabled?: boolean
}

export function BonusFormGroup(props: RequiredAchievementFormGroupProps) {
  const {
    value, onChange, disabled, ...rest
  } = props;

  return (
    <FormGroup as={Col} controlId="isBonus" className={cs.formGroup}>
      <FormCheck
        custom
        name="isBonus"
        disabled={disabled}
        checked={value}
        onChange={(e) => onChange(e.target.checked)}
        label="Is Bonus"
        {...rest}
      />

    </FormGroup>
  );
}
